import React, { useEffect, useState } from "react";

import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import BotonSalirLimiarStorageCatalogo from "./BotonSalirLimpiarStorageCatalogo";
import FormInformacionLocal from "../components/FormInformacionLocal";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const DetalleInformacionLocal = ({  
  idLocal,
  local, 
}) => {
  const [value, setValue] = useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  // const [idLocalInformacion, setIdLocalInformacion] = useState(idLocal);

  useEffect(() => {
    console.log({ idLocal });
    console.log({ local });
  }, []);

  return (
    <>
      <BotonSalirLimiarStorageCatalogo />
      <Box sx={{ width: "100%" }}>
        <Box
          sx={{ borderBottom: 1, borderColor: "divider" }}
          className="cabecera-tabs-clientes"
        >
          {/* <Tabs
            value={value}
            onChange={handleChange}
            aria-label="basic tabs example"
            textColor="inherit"
            variant="fullWidth"
          >
            <Tab label="Información Local" {...a11yProps(0)} />
          </Tabs> */}
        </Box>
        <TabPanel value={value} index={0}>
          <FormInformacionLocal
            idLocal={idLocal}
            local={local}
          />
        </TabPanel>
      </Box>
    </>
  );
};

export default DetalleInformacionLocal;
